import { useCallback, useMemo } from 'react';
export default function useEditorVisibility(opts) {
  const {
    dataViewerId,
    overrideModel,
    overrides
  } = opts;
  const editorVisible = useMemo(() => {
    return overrideModel?.editorVisible;
  }, [overrideModel]);
  const onToggleEditor = useCallback(() => {
    const current = !!overrideModel?.editorVisible;
    overrides.set(dataViewerId, 'editorVisible', !current);
  }, [dataViewerId, overrideModel, overrides]);
  return useMemo(() => {
    return {
      editorVisible,
      onToggleEditor
    };
  }, [editorVisible, onToggleEditor]);
}